import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import styles from './NotFoundPage.module.scss';

export default function NotFoundPage() {
    const location = useLocation();

    return (
        <div className={styles.container}>
            <h3>No match for <code>{location.pathname}</code></h3>
            <Link to="/">To Home</Link>
        </div>
    );
}
